namespace RedBullMOBILE360.CVM {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CVM.CriteriaConditionDialog')
    export class CriteriaConditionDialog extends Serenity.EntityDialog<CriteriaConditionRow, any> {
        protected getFormKey() { return CriteriaConditionForm.formKey; }
        protected getIdProperty() { return CriteriaConditionRow.idProperty; }
        protected getLocalTextPrefix() { return CriteriaConditionRow.localTextPrefix; }
        protected getNameProperty() { return CriteriaConditionRow.nameProperty; }
        protected getService() { return CriteriaConditionService.baseUrl; }
        protected getDeletePermission() { return CriteriaConditionRow.deletePermission; }
        protected getInsertPermission() { return CriteriaConditionRow.insertPermission; }
        protected getUpdatePermission() { return CriteriaConditionRow.updatePermission; }

        protected form = new CriteriaConditionForm(this.idPrefix);
    }
}